import React, { useState, useEffect, useRef } from 'react';
import { Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import delay from 'delay';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// icons
import { RiShoppingBagFill, RiCloseLine } from 'react-icons/ri';
// slices
import { cartSelector, removeItem, removeGiftCard } from 'slices/cart';
import { userSelector } from 'slices/user';
//utils
import { formatCurrency } from 'utils/currencyFormatter';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import MiniCart from 'components/navbar/MiniCart';

const ProductBarDesktop = () => {
  const { t } = useTranslation(['header']);
  const [showToast, setShowToast] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const location = useLocation();
  const { assignedLibrary } = useAssignedLibrary();

  const { items, countItems, total } = useSelector(cartSelector);
  const { profile, info_concourse, isLogged } = useSelector(userSelector);
  const previousCounterValue = useRef(countItems);
  const dispatch = useDispatch();

  useEffect(() => {
    setModalShow(false);
  }, [location]);

  useEffect(() => {
    (async () => {
      if (countItems !== previousCounterValue.current) {
        await delay(180);
        setShowToast(true);
      }
    })();
  }, [countItems]);

  useEffect(() => {
    (async () => {
      if (showToast) {
        await delay(3000);
        setShowToast(false);
      }
    })();
  }, [showToast]);



  return (
    <Col lg={3} className="header__products d-none d-lg-block">

      <button id="dropTrolley"
        className={`${countItems > 0 && 'mw-231'}`}
        onClick={() => setModalShow(true)}
        role="button"
      >
        <div className="info-cart-products">
          {
            countItems > 0 && (
              <>
                <span className="number-products">
                  <span className="number">{`${countItems} ${countItems !== 1 ? t('productos') : t('producto')}`}</span>
                </span>
                <span className="divider">|</span>
                <span className="total" data-testid="total-product">{total && formatCurrency(total)}</span>
              </>
            )
          }
          {
            isLogged && countItems === 0 && profile === 'library' && (
              <span>{t('emptyCart')}</span>
            )
          }
          {
            isLogged && profile === 'library' && (
              <p>{`${t('remaining')}: ${formatCurrency(info_concourse.remaining_budget)}`}</p>
            )
          }

        </div>
        <RiShoppingBagFill className="icon-md fas-shopping-bag" />
      </button>

      {modalShow && (
        <div className="modal-container">
          <div id="trolleyArea" className={modalShow ? 'd-block' : 'd-none'}>
            <div className="modal-header">
              <h3 className="section cart">{t('ultimosProductos')}</h3>
              <button className="close" onClick={() => setModalShow(false)}>
                <RiCloseLine className="icon-md fas-closing" />
              </button>
            </div>
            <div className="modal-body">
              {countItems === 0 ? <h5>{t('noproducts')}</h5> : <MiniCart items={items} />}
            </div>
            {countItems !== 0 && (
              <div className="modal-footer">
                <Link className="modal-footer__link bg-info" to={`/${assignedLibrary}/carrito`} onClick={() => setModalShow(false)}>
                  {t('comprar')}
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </Col>
  );
};

export default ProductBarDesktop;
